// Import controller interfaces
import {
    IAuthenticationController
} from '../Interfaces/ControllerInterfacesBarrel';

export default class MockAuthenticationController implements IAuthenticationController {

    public constructor() {

    }

    public async authenticatePolicyAccess(policyId: number): Promise<boolean> {
        throw new Error('Method not implemented.');
    }

    public async authenticatePolicyAccessPublic(policyId: number, zipCode: string): Promise<boolean> {
        throw new Error('Method not implemented.');
    }

};